/** `text` with its first character uppercased and the rest unchanged; an empty string stays empty. */
export function capitalizeFirst(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
